import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './OurProducts.css'
import ParallaxBasic from '../../components/page/parallaxBasic/ParallaxBasic.jsx'
import HeroImage from './hero-our-products.jpg'
import FilterProducts from '../../components/page/filterProducts/FilterProducts.jsx'
import CTA from '../../components/page/cta/CTA.jsx'
import Block1Background from './strawberry-fruit-bar-bowl.jpg'
import Block2FruitBar from './fruit-bars.png'
import Slider from '../../components/global/slider/Slider.jsx'
import PrevArrow from '../../components/global/slider/prevArrow/PrevArrow.jsx'
import NextArrow from '../../components/global/slider/nextArrow/NextArrow.jsx'
import CTAImage1 from './Red-Raspberry-Tower-768x668.png'
import CTAImage2 from './Pina-Colada-Tower-768x628.png'
import Footer from '../../components/global/footer/Footer.jsx'
import ProductsData from './ProductsData'
import Modal from 'react-modal'

// let Scroller = Scroll.scroller;

/**
 * Modal styles
 *
 * @type {{content: {top: string, bottom: string, left: string, right: string, border: string, borderRadius: string, backgroundColor: string, overflow: string}, overlay: {backgroundColor: string}}}
 */
const modalStyles = {
  content: {
    top: '0',
    bottom: '0',
    left: '0',
    right: '0',
    border: 'none',
    borderRadius: '0',
    overflow: 'hidden'
  },
  overlay: {
    backgroundColor: 'rgba(25, 25, 25, 0)'
  }
}

/**
 * @class OurProducts
 * @namespace Architect\React\Views
 * @author Mike Rudling <mrudling@wearearchitect.com>
 */
export default class OurProducts extends Component {
  /**
   * Default props
   *
   * @type {{scrollOptions: {duration: number, delay: number, smooth: boolean}, ctaText: string, gridBlocksData: *[]}}
   */
  static defaultProps = {
    heroImage: HeroImage,
    parallaxTitle: 'Our Products',
    parallaxSubTitle:
      'Every Solero® Crushed Fruit Bar and Pop is made with sweet, sun-ripened fruit, carefully crushed, blended and frozen to cool, flavor-packed perfection.',
    ctaText: 'Find out where to buy our products',
    ctaButtonText: 'Where to Buy',
    scrollOptions: {
      duration: 1500,
      delay: 100,
      smooth: true
    },
    gridBlocksData: [
      {
        header: true,
        image: Block1Background,
        imageAlt: 'Background'
      },
      {
        image: Block2FruitBar,
        imageAlt: 'Coconut',
        text:
          'Every Solero® Crushed Fruit product is made with sweet, sun-ripened fruit, carefully crushed, blended and frozen to cool, flavor-packed perfection. '
      }
    ],
    parallaxBasicClassNames: classNames('ParallaxBasic', 'Parallax__group', 'ParallaxBasic--short'),
    gridBlocksClassNames: classNames('GridBlocks', 'GridBlocks--short'),
    sliderData: [],
    sliderSettings: {
      dots: false,
      infinite: true,
      initialSlide: 5,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />
    }
  }

  /**
   * Prop types
   *
   * @type {{heroImage: shim, ctaText: shim, gridBlocksData, scrollOptions: shim, parallaxBasicClassNames: shim, gridBlocksClassNames: shim, sliderData, sliderSettings: shim}}
   */
  static propTypes = {
    heroImage: PropTypes.string,
    ctaText: PropTypes.string,
    gridBlocksData: PropTypes.arrayOf(PropTypes.object),
    scrollOptions: PropTypes.object,
    parallaxBasicClassNames: PropTypes.string,
    gridBlocksClassNames: PropTypes.string,
    sliderData: PropTypes.arrayOf(PropTypes.object),
    sliderSettings: PropTypes.object
  }

  /**
   * State
   *
   * @type {{sliderData: Array}}
   */
  state = {
    sliderData: []
  }

  /**
   * Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props)

    this.setSliderData = this.setSliderData.bind(this)
    this.openModalPopup = this.openModalPopup.bind(this)
    this.closeModalPopup = this.closeModalPopup.bind(this)
  }

  /**
   * Component did mount
   */
  componentDidMount() {
    let list = ProductsData.products
    let sliderData = [...list.cream, ...list.organic, ...list.natural, ...list.pops]

    this.setSliderData(sliderData)
  }

  /**
   * Set slider data
   *
   * @param sliderData
   */
  setSliderData(sliderData) {
    this.setState({
      sliderData: sliderData
    })
  }

  /**
   * Initial state
   *
   * @type {{popupIsOpen: boolean}}
   */
  state = {
    popupIsOpen: false
  }

  /**
   * Open modal popup
   *
   * @param event
   */
  openModalPopup(event) {
    let list = ProductsData.products
    let sliderIndex = Number(event.target.getAttribute('data-index'))
    let sliderType = event.target.getAttribute('data-type')
    let sliderData = list[sliderType]

    this.setSliderData(sliderData)

    let sliderSettings = {
      dots: false,
      infinite: true,
      initialSlide: sliderIndex,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />
    }

    this.setState({
      popupIsOpen: true,
      sliderSettings: sliderSettings
    })
  }

  /**
   * Close modal popup
   *
   * @param event
   */
  closeModalPopup(event) {
    this.setState({
      popupIsOpen: false
    })
  }

  /**
   * Render
   *
   * @returns {XML}
   */
  render() {
    const {
      heroImage,
      parallaxTitle,
      parallaxSubTitle,
      ctaText,

      parallaxBasicClassNames,

      ctaButtonText,
      setHeaderClassNames
    } = this.props

    const { popupIsOpen, sliderData, sliderIndex, sliderSettings } = this.state

    return (
      <main className="OurProducts Parallax">
        <ParallaxBasic
          background={heroImage}
          parallaxBasicClassNames={parallaxBasicClassNames}
          parallaxTitle={parallaxTitle}
          parallaxSubTitle={parallaxSubTitle}
          setHeaderClassNames={setHeaderClassNames}
        />

        <section>
          <Modal isOpen={popupIsOpen} closeTimeoutMS={2} style={modalStyles} contentLabel="Modal" ariaHideApp={false}>
            <Slider
              data={sliderData}
              index={sliderIndex}
              settings={sliderSettings}
              closeModalPopup={this.closeModalPopup}
            />
          </Modal>
        </section>

        <FilterProducts
          filterOnFields={ProductsData.categoriesList}
          products={ProductsData.products}
          openModalPopup={this.openModalPopup}
          setSliderData={this.setSliderData}
        />

        <CTA ctaText={ctaText} image1={CTAImage1} image2={CTAImage2} buttonText={ctaButtonText} link="/where-to-buy" />

        <Footer />
      </main>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/ourProducts/OurProducts.jsx